import { InvoicingHistory } from '../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/invoiceHistoryTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  invoiceHistoryDetailsApiConfig,
} from '../../../../apiList'

const invoiceTimeLine = async (
  invoiceId: number,
): Promise<InvoicingHistory[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: invoiceHistoryDetailsApiConfig.invoiceHistory,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const invoiceTimeLineApi = {
  invoiceTimeLine,
}

export default invoiceTimeLineApi
